import React from 'react';

export const VolEventDateModal = {
  title: 'Event Date',
  body: (
    <div>
      <p>
        Where available, this date (SYYYY-MM-DD) indicates the peak of activity. For example, the date that deaths, damage, or corresponding tsunami or earthquake occurred.
      </p>
    </div>
  ),
};
